import axios from 'axios';
import { User, AuthResponse, LoginCredentials, RegisterCredentials } from '../types/user';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

class AuthService {
  private token: string | null = null;

  constructor() {
    this.token = localStorage.getItem('token');
    if (this.token) {
      this.setAuthHeader(this.token);
    }
  }

  private setAuthHeader(token: string) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  private clearAuthHeader() {
    delete axios.defaults.headers.common['Authorization'];
  }

  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    try {
      const response = await axios.post<AuthResponse>(`${API_BASE_URL}/auth/login`, credentials);
      this.token = response.data.token;
      this.setAuthHeader(this.token);
      localStorage.setItem('token', this.token);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  }

  async register(credentials: RegisterCredentials): Promise<AuthResponse> {
    try {
      const response = await axios.post<AuthResponse>(`${API_BASE_URL}/auth/register`, credentials);
      this.token = response.data.token;
      this.setAuthHeader(this.token);
      localStorage.setItem('token', this.token);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Registration failed');
    }
  }

  async verifyToken(token: string): Promise<User> {
    try {
      this.setAuthHeader(token);
      const response = await axios.get<{ user: User }>(`${API_BASE_URL}/auth/verify`);
      return response.data.user;
    } catch (error) {
      this.clearAuthHeader();
      throw error;
    }
  }

  logout() {
    this.token = null;
    this.clearAuthHeader();
    localStorage.removeItem('token');
  }

  isAuthenticated(): boolean {
    return !!this.token;
  }

  getToken(): string | null {
    return this.token;
  }
}

export const authService = new AuthService();